import { Dialog } from '@angular/cdk/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ownerFieldsMap, ROUTES, workspaceFieldsMap } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { ConfirmationPopupWithFormComponent } from 'libs/shared/ui-components/src/lib/confirmation-popup-with-form/confirmation-popup-with-form.component';
import { ToastrService } from 'ngx-toastr';
import { max } from 'rxjs';

@Component({
  selector: 'app-create-workspace',
  templateUrl: './create-workspace.component.html',
  styleUrls: ['./create-workspace.component.scss']
})
export class CreateWorkspaceComponent {
  step = 0;
  steps = ['Workspace Details', 'User Attributes', 'Workspace Owner Details ', 'Subscription Plan'];
  loaderView: boolean = true;
  signInMethodList: any;
  selectedValue: string = '';
  selectedLoactions: string[] = [];
  selectedAcronyms: string[] = [];
  allowedDomains: string[] = [];
  userAssetCode: string = '';
  assetTemplateFields = ['Acronym', 'Financial Year', 'Asset Type', 'Number'];
  previewUrl: string | ArrayBuffer | null = null;
  codeTemplate: string[] = [];
  maxDate: string = '';
  noFutureDateValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null; 
  const selected = new Date(control.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return selected > today ? { futureDate: true } : null;
}
  workspaceDetails: FormGroup = new FormGroup({
    workspaceName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!^\s)(?!.*\s$)[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/)]),
    authTypeId: new FormControl('', Validators.required),
    acronymLength: new FormControl('', [Validators.required, Validators.max(4), Validators.min(1)]),
    initialAssetNumber: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(5)]),
    companyName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
    companyWebsiteLink: new FormControl('', [Validators.required, Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]),
    establishmentDate: new FormControl('', [Validators.required, this.noFutureDateValidator]),
  })
  groupedConfigs: { [key: string]: any[] } = {};
  assetDetails: any;
  editFormData: any;
  payload: any;
  workspaceId: string | null = null;
  planId: string | null = null;
  ownerId: string | null = null;
  owner: any | null = null
  options: any[] = ['Standard Plan'];
  errors:any={};
  isLoading = false;
  // flags
  isNewWorkspaceDetails = false;
  isNewUserAttributes = false;
  isNewWorkspaceOwnerDetails = false;
  // workspaceOwnerDetails
  workspaceOwnerDetails: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!^\s)(?!.*\s$)[A-Za-z]+(?:\s[A-Za-z]+)*$/)]),
    lastName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!^\s)(?!.*\s$)[A-Za-z]+(?:\s[A-Za-z]+)*$/)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    empId: new FormControl('', Validators.required),
    phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]),
    empStatus: new FormControl('', Validators.required),
    empType: new FormControl('', Validators.required),
    designation: new FormControl('', Validators.required),
  })
  statusList: string[] = [];
  typeList: string[] = [];
  designationList: string[] = [];
  isPasswordField: boolean = false;
  attributeIds: string[] = [];
  workspaceDetailsDisable = false;
  userAttributesDisable = false;
  workspaceOwnerDetailsDisable = false;
  workspaceError:{[key:string]:string}={};

  constructor(
    private commonHttpService: CommonHttpService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private cdr: ChangeDetectorRef,
    private dialog: Dialog,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
    this.getSignInMethods();
    this.userAssetCode = 'CSL/24-25/L/8464';
    this.assetDetails = {
      categories: [
        { name: 'Employee Type', displayName: 'Employee Type' },
        { name: 'Employee Status', displayName: 'Employee Status' },
        { name: 'Employee Designation', displayName: 'Employee Designation' }
      ],
      configs: [
        {
          category: 'Employee Type',
          displayName: 'empType',
          values: [],
          list: false
        },
        {
          category: 'Employee Status',
          displayName: 'empStatus',
          values: [],
          list: false
        },
        {
          category: 'Employee Designation',
          displayName: 'designation',
          values: [],
          list: true
        }
      ]
    };
    this.groupConfigsByCategory();
    this.getPlans();
    this.codeTemplate = [this.getCodeTemplate(this.selectedAcronyms[0])];
  }
  getPlans() {
    this.loaderView = true;
    this.commonHttpService.getPlans().subscribe({
      next: (respone: any) => {
        this.options = respone.data.map((value: any) => ({
          name: value.name,
          id: value.id
        }))
        this.loaderView = false;
      }
    })
    this.codeTemplate = [this.getCodeTemplate(this.selectedAcronyms[0])];
  }
  getSignInMethods() {
    this.loaderView = true;
    this.commonHttpService.getSignInMethods().subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.signInMethodList = Object.values(response.data).map((method: any) => ({
            name: method.displayName,
            id: method.id
          }))
        }
        this.loaderView = false;
      },
      error: (error) => {
        this.toastrService.error('Error Fetching Data', '', {
              toastClass: 'toaster-wrapper',
            });
      }
    })
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.assetTemplateFields, event.previousIndex, event.currentIndex);

    const templateParts = this.selectedAcronyms.map((acronym) => {
      const parts = this.assetTemplateFields.map(field => {
        switch (field) {
          case 'Acronym': return acronym;
          case 'Financial Year': return '${financialYear}';
          case 'Asset Type': return '${assetTypeCode}';
          case 'Number': return '${assetNumber}';
          default: return '';
        }
      });

      return parts.join('-');
    });
    const exampleAssetCode = this.assetTemplateFields.map(field => {
      switch (field) {
        case 'Acronym': {
          return this.selectedAcronyms[0] ? this.selectedAcronyms[0] : 'CSL';
        }
        case 'Financial Year': return '24-25';
        case 'Asset Type': return 'L';
        case 'Number': {
          const val = this.workspaceDetails.controls['initialAssetNumber'].value;
          return val !== '' ? val : '8464';
        }
        default: return '';
      }
    }).join('/');

    this.codeTemplate = templateParts;
    this.userAssetCode = exampleAssetCode;
  }
  getCodeTemplate(acronym: string) {
    return `${acronym}` + '-${financialYear}-${assetTypeCode}-' + `${this.workspaceDetails.controls['initialAssetNumber'].value !== "" ? this.workspaceDetails.controls['initialAssetNumber'].value : '${assetNumber}'}`
  }
  getValueOfMethod(event: any) {
    this.workspaceDetails.controls['authTypeId'].setValue(event);
  }
  getIdOfType(event: any) {
    this.workspaceOwnerDetails.controls['empType'].setValue(event);
  }
  getIdOfStatus(event: any) {
    this.workspaceOwnerDetails.controls['empStatus'].setValue(event);
  }
  getIdOfDesignation(event: any) {
    this.workspaceOwnerDetails.controls['designation'].setValue(event);
  }
  handleValue(event: any) {
    this.planId = event;
  }
  // validation
  workspaceDetailsHasError(controlName: string): boolean {
  const control = this.workspaceDetails.get(controlName);

  if (control && (control.dirty || control.touched) && control.errors) {
    if (control.errors['required']) {
      this.workspaceError[controlName] = 'This field is required';
    } else if (control.errors['pattern']) {
      this.workspaceError[controlName] = 'Invalid format';
    } else {
      this.workspaceError[controlName] = 'Invalid input';
    }
    return true;
  }

  this.workspaceError[controlName] = ''; // Clear message if no error
  return false;
}
  workspaceOwnerHasError(controlName: string) {
    const control = this.workspaceOwnerDetails.get(controlName);
    return control?.dirty && control?.errors;
  }
  addControl(val: string) {
    const validators = [Validators.required];
    if (val === 'acronym') {
      const length = +this.workspaceDetails.controls['acronymLength'].value;
      if (!length || length <= 0) {
        this.toastrService.error('Please set Acronym Length before adding acronyms', '', {
              toastClass: 'toaster-wrapper',
            });
        return;
      }
      validators.push(Validators.minLength(length), Validators.maxLength(length), Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/));
    } else if (val === 'domain') {
      validators.push(Validators.pattern(/^\S+\.(com|in|org)$/i));
    } else if (val === 'location') {
      validators.push(Validators.pattern(/^(?!.*\s{2,})(?!^\s)(?!.*\s$)[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/));
    }
    const confirmationForm = new UntypedFormGroup({
      response: new UntypedFormControl('', validators)
    });
    const formData = {
      header: `Add ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
      description: `Please enter the ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
      image: 'cautionImage',
      form: { confirmationForm: confirmationForm },
      fields: [
        {
          field: 'text-field',
          controlName: 'response',
          placeholder: `Enter ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain as google.com, coditas.com'}`,
          label: `${val === 'acronym' ? 'Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
          error: `${val === 'acronym' ? 'Invalid Length of Acronym' : val === 'location' ? 'Invalid Location' : 'Invalid Domain'}`,
          isAcronym: val === 'acronym'
        },
      ],
      secondaryBtn: 'Cancel',
      primaryBtn: 'Add',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        if (val === 'acronym') {
          this.selectedAcronyms.push(result.response.toUpperCase());
          this.codeTemplate = this.selectedAcronyms.map((acr) => this.getCodeTemplate(acr));
        } else if (val === 'location') {
          this.selectedLoactions.push(result.response);
        } else if (val === 'domain') {
          this.allowedDomains.push(result.response);
        }
      }
    });
  }
  onInputChange(field: string, event: any) {
    if (workspaceFieldsMap[field]) {
      this.workspaceDetails.get(workspaceFieldsMap[field])?.setValue(event.target.value);
    } else if (ownerFieldsMap[field]) {
      this.workspaceOwnerDetails.get(ownerFieldsMap[field])?.setValue(event.target.value);
    }
  }
  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
  onNextStepRequested() {
    this.isLoading = false;
    this.handleNext(this.step);
  }

  handleNext(step: number) {
    if (step === 0) {
      if (this.isNewWorkspaceDetails) {
        this.step++;
      } else {
        if (this.isLoading) return;
        this.isLoading = true
        const payload = {
          "name": this.workspaceDetails.controls['workspaceName'].value,
          "codeTemplate": this.codeTemplate,
          "acronyms": this.selectedAcronyms,
          "authTypeId": this.workspaceDetails.controls['authTypeId'].value,
          "allowedDomains": this.allowedDomains,
          "acronymLength": this.workspaceDetails.controls['acronymLength'].value,
          "initialAssetNumber": this.workspaceDetails.controls['initialAssetNumber'].value,
          "locations": this.selectedLoactions,
          "establishmentDate": this.workspaceDetails.controls['establishmentDate'].value,
          "companyName": this.workspaceDetails.controls['companyName'].value,
          "companyWebsiteLink": this.workspaceDetails.controls['companyWebsiteLink'].value.startsWith('http') ? this.workspaceDetails.controls['companyWebsiteLink'].value : `https://${this.workspaceDetails.controls['companyWebsiteLink'].value}`
        }
        this.commonHttpService.sendCreateWorkspaceDetails(payload).subscribe({
          next: (response: any) => {
            this.workspaceId = response.data.id;
            this.toastrService.success('Workspace Details Added Successfully!', '', {
              toastClass: 'toaster-wrapper',
            });
            this.step++;
            this.isNewWorkspaceDetails = true;
            this.isLoading = false
            this.workspaceDetailsDisable = true;
          },
          error: (err) => {
            this.isLoading = false;
            const errorList = err.error?.error?.errorList;
            const errorMessage = Array.isArray(errorList)
              ? errorList[0]?.msg || 'Error creating workspace'
              : errorList || 'Error creating workspace';
            this.toastrService.error(errorMessage, '', {
              toastClass: 'toaster-wrapper',
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        })
      }
    } else if (step === 1) {
      if (this.isNewUserAttributes) {
        this.step++;
      } else {
        this.payload = {
          workspaceId: this.workspaceId,
          attributes: [
            ...Object.entries(this.groupedConfigs)
              .flatMap(([category, configs]) =>
                configs
                  .map(cfg => ({
                    attributeName: cfg.displayName,
                    attributeValues: cfg.values || []
                  }))
              )
          ]
        };
        this.commonHttpService.addUserAttribute(this.payload).subscribe({
          next: (response: any) => {
            this.getOwnerDetails();
            this.workspaceOwnerDetails.controls['empStatus'].setValue(response.data[1].attributeValue);
            this.workspaceOwnerDetails.controls['empType'].setValue(response.data[0].attributeValue);
            this.workspaceOwnerDetails.controls['designation'].setValue(response.data[2].attributeValue);
            this.attributeIds = response.data.map((attribute: any) => attribute.id);
            this.toastrService.success('User Attributes Added Successfully!', '', {
              toastClass: 'toaster-wrapper',
            });
            this.step++;
            this.isLoading = false
            this.isNewUserAttributes = true;
            this.userAttributesDisable = true;
          },
          error: (err) => {
            const errorList = err.error?.error?.errorList;
            const errorMessage = Array.isArray(errorList)
              ? errorList[0]?.msg || 'Error Adding Attributes'
              : errorList || 'Error Adding Attribute';
            this.toastrService.error(errorMessage, '', {
              toastClass: 'toaster-wrapper',
            });
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        })
      }
    } else if (step === 2) {
      const payload = {
        "firstName": this.workspaceOwnerDetails.controls['firstName'].value,
        "lastName": this.workspaceOwnerDetails.controls['lastName'].value,
        "email": this.workspaceOwnerDetails.controls['email'].value,
        "employeeId": this.workspaceOwnerDetails.controls['empId'].value,
        "empStatus": this.workspaceOwnerDetails.controls['empStatus'].value,
        "empType": this.workspaceOwnerDetails.controls['empType'].value,
        "designation": this.workspaceOwnerDetails.controls['designation'].value,
        "phoneNumber": this.workspaceOwnerDetails.controls['phoneNumber'].value,
        "isUserOnboarded": true,
        "roleId": 'WORKSPACE-OWNER'
      }
      if (this.isNewWorkspaceOwnerDetails) {
        this.step++;
      } else {
        this.loaderView = true;
        this.commonHttpService.sendCreateWorkspaceOwnerDetails(payload, this.workspaceId!).subscribe({
          next: (response: any) => {
            this.owner = response.data.createdUser;
            this.ownerId = response.data.createdUser.id
            this.toastrService.success('Workspace Owner Added Successfully!', '', {
              toastClass: 'toaster-wrapper',
            });
            this.step++;
            this.isNewWorkspaceOwnerDetails = true;
            this.workspaceOwnerDetailsDisable = true;
            this.loaderView = false;
          },
          error: (err) => {
            const errorList = err.error?.error?.errorList;
            const errorMessage = Array.isArray(errorList)
              ? errorList[0]?.msg || 'Error Adding Workspace Owner Details'
              : errorList || 'Error Adding Workspace Owner Details';
            this.toastrService.error(errorMessage, '', {
              toastClass: 'toaster-wrapper',
            });
            this.loaderView = false;
          },
          complete: () => {
            this.loaderView = false;
          }
        })
      }
    }

  }
  handleSubmit() {
    const payload = {
      workspaceId: this.workspaceId,
      planId: this.planId,
      purchasedBy: this.ownerId
    }
    this.loaderView = true;
    this.commonHttpService.sendWorspaceDetails(payload).subscribe({
      next: (response: any) => {
        this.toastrService.success('Workspace Created Successfully!', '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
        this.router.navigate([ROUTES.SUPER_ADMIN_DASHBOARD]);
      },
      error: (err) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error Adding Details'
          : errorList || 'Error Adding Details';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      }
    })
  }

  groupConfigsByCategory() {
    this.groupedConfigs = {};
    this.assetDetails.configs.forEach((config: any) => {
      if (!this.groupedConfigs[config.category]) {
        this.groupedConfigs[config.category] = [];
      }
      this.groupedConfigs[config.category].push(config);
    });
  }

  getValuesDisplay(config: any): string {
    return config.values?.length ? config.values.join(', ') : 'Not added';
  }
  onEditConfig(categoryName: string, configIndex: number): void {
    const config = this.groupedConfigs[categoryName][configIndex];

    this.editFormData = {
      header: `Edit ${categoryName}`,
      description: `Modify values for ${categoryName}`,
      image: 'editImage',
      form: {
        confirmationForm: new FormGroup({
          property: new FormControl({ value: config.displayName, disabled: true }),
          value: new FormControl(config.values?.join(', ') || ''),
        }),
      },
      includeUnits: false,
      includeIsRequired: false,
      fields: [
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: `E.g. ${categoryName === 'Employee Type' ? 'On Probation' : categoryName === 'Employee Status' ? 'Active' : 'Intern'}`,
          label: 'Value(s)',
        },
      ],
      primaryBtn: 'Save'
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: this.editFormData
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const newValues = result.value
          ? result.value.map((v: string) => v.trim()).filter((v: string) => v.length > 0)
          : [];

        this.groupedConfigs[categoryName][configIndex].values = newValues;
        const globalIndex = this.assetDetails.configs.findIndex(
          (c: any) => c.category === categoryName && c.displayName === config.displayName
        );

        if (globalIndex !== -1) {
          this.assetDetails.configs[globalIndex].values = newValues;
        }

        this.payload = {
          workspaceId: this.workspaceId,
          attributes: [
            ...Object.entries(this.groupedConfigs)
              .flatMap(([category, configs]) =>
                configs
                  .map(cfg => ({
                    attributeName: cfg.displayName,
                    attributeValues: cfg.values || []
                  }))
              )
          ]
        };
      }
    });
  }

  // workplaceOwnerDetails
  getOwnerDetails() {
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'empStatus').subscribe({
      next: (response: any) => this.statusList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'empType').subscribe({
      next: (response: any) => this.typeList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'designation').subscribe({
      next: (response: any) => this.designationList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
  }

  deleteListData(list: string, value: string) {
    if (list === 'location') {
      this.selectedLoactions.splice(this.selectedLoactions.findIndex((item) => item === value), 1);
    } else if (list === 'acronyms') {
      this.selectedAcronyms.splice(this.selectedAcronyms.findIndex((item) => item === value), 1);
      this.codeTemplate = this.selectedAcronyms.map((acr) => this.getCodeTemplate(acr));
    } else {
      this.allowedDomains.splice(this.allowedDomains.findIndex((item) => item === value), 1)
    }
  }

}